import {
  AfterViewChecked,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-mobile-fixed-panel',
  templateUrl: './mobile-fixed-panel.component.html',
  styleUrls: ['./mobile-fixed-panel.component.scss'],
})
export class MobileFixedPanelComponent implements OnInit, AfterViewChecked {
  @Input() public parentElementRef?: ElementRef;
  @ViewChild('panel') public panelElementRef: ElementRef;

  private readonly paddingReset = 'initial';
  private readonly subscriptions = new Subscription();

  public isTabletDevice: boolean;

  constructor(private readonly matchMediaService: MatchMediaService) {}

  public ngAfterViewChecked(): void {
    if (!this.parentElementRef) {
      return;
    }

    if (!this.isTabletDevice) {
      this.resetPaddingToRefElement(this.parentElementRef);

      return;
    }

    this.addPaddingToRefElement(this.parentElementRef);
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isTabletDevice().subscribe((isTabletDevice) => {
        this.isTabletDevice = isTabletDevice;
      })
    );
  }

  public addPaddingToRefElement(elementRef: ElementRef): void {
    const elementRefStyle = elementRef.nativeElement.style;

    if (
      elementRefStyle.paddingBottom !== '' &&
      elementRefStyle.paddingBottom !== this.paddingReset
    ) {
      return;
    }

    const panelRefHeight = this.panelElementRef.nativeElement.offsetHeight;

    elementRefStyle.display = 'block'; // set display to angular element for apply padding
    elementRefStyle.paddingBottom = `${panelRefHeight}px`;
  }

  public resetPaddingToRefElement(elementRef: ElementRef): void {
    const elementRefStyle = elementRef.nativeElement.style;

    if (
      elementRefStyle.paddingBottom === '' ||
      elementRefStyle.paddingBottom === this.paddingReset
    ) {
      return;
    }

    elementRefStyle.paddingBottom = this.paddingReset;
  }
}
